// Minimum length requirement
export const PASSWORD_MIN_LENGTH = 8;

// Individual character-class regexes
export const RE_UPPERCASE = /[A-Z]/;
export const RE_LOWERCASE = /[a-z]/;
export const RE_NUMBER = /\d/;
export const RE_SPECIAL = /[@$!%*?&-]/;

// Combined regex (all four character classes in one test)
export const RE_PASSWORD_COMPLEXITY = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])/;

/**
 * Returns an object with a boolean for each requirement.
 */
export const getPasswordValidation = (password) => ({
  minLength: password.length >= PASSWORD_MIN_LENGTH,
  hasUpperCase: RE_UPPERCASE.test(password),
  hasLowerCase: RE_LOWERCASE.test(password),
  hasNumber: RE_NUMBER.test(password),
  hasSpecialChar: RE_SPECIAL.test(password),
});

/**
 * Returns true only when every requirement is satisfied.
 */
export const isPasswordValid = (password) =>
  Object.values(getPasswordValidation(password)).every(Boolean);
